/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* @import '@ionic/vue/css/palettes/dark.always.css'; */
import "@ionic/vue/css/palettes/dark.class.css";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

/* Theme variables */
import "./theme/variables.css";
import "./theme/style.css";

import { initDarkModePalette } from "./app/utils/darkMode";
import { initServiceWorkerUpdates } from "./app/utils/pwaUpdate";

import { createApp } from "vue";
import { IonicVue } from "@ionic/vue";
import { createPinia } from "pinia";
import { piniaCapacitorPersist } from "./app/store/piniaCapacitorPersist";

import * as Sentry from "@sentry/vue";

import App from "./app/App.vue";
import router from "./app/router";

import BaseLayout from "./app/layouts/BaseLayout.vue";

defineCustomElements(window);
initDarkModePalette();
initServiceWorkerUpdates();

const pinia = createPinia();
pinia.use(piniaCapacitorPersist);

const app = createApp(App).use(IonicVue).use(router).use(pinia);

app.component("base-layout", BaseLayout);

Sentry.init({
  app,
  dsn: "https://45c7aeb904be59fba435235afb305f46@o4509875270451200.ingest.de.sentry.io/4509875277332560",
  // Not an app error: the user backing out of the native photo picker. Only
  // reachable today from stale pre-redesign PWA bundles still cached on some
  // devices (the current camera flow — CameraCapture.vue — never throws
  // this), so filtering it out here is safe rather than chasing dead code.
  ignoreErrors: ["User cancelled photos app"],
});

router.isReady().then(() => {
  app.mount("#app");
});
